import VisiteList from "./components/VisiteList.vue";
import VisitaView from "./components/VisitaView.vue";
import VisitaEdit from "./components/VisitaEdit.vue";
export default {
    VisiteList,
    VisitaView,
    VisitaEdit,
};
